import React from "react";

const SHOWCASE_INFOGRAPHIC =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_gland-positioning/artifacts/24aad6e35195bd81_IMG_2423.webp";
const SHOWCASE_PACKAGING =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_gland-positioning/artifacts/1be13031e7237d60_IMG_2428.jpeg";

export const ProductShowcase = () => {
  return (
    <section
      data-testid="product-showcase"
      className="relative py-24 md:py-36 border-t border-[#27272A] bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span className="label-eyebrow">04 / Product Showcase</span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tighter mt-4">
              One tool. Three sizes.{" "}
              <span className="text-[#FF6B00]">Endless accuracy.</span>
            </h2>
          </div>
          <div className="font-mono-spec text-[11px] uppercase tracking-[0.22em] text-[#A1A1AA] max-w-xs">
            20mm · 25mm · 32mm gland sizes · dual metric &amp; imperial scales · 6&quot; (150mm) travel
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-px bg-[#27272A] border border-[#27272A] rounded-sm overflow-hidden">
          {/* Infographic / how it works */}
          <div
            data-testid="showcase-infographic"
            className="lg:col-span-8 bg-white p-0 relative min-h-[500px] overflow-hidden flex flex-col"
          >
            <div className="bg-[#0A0A0A] px-4 py-3 border-b border-[#27272A] flex items-center justify-between">
              <span className="font-mono-spec text-[10px] uppercase tracking-[0.22em] text-[#A1A1AA]">
                CAD · Engineering View
              </span>
              <span className="font-mono-spec text-[10px] uppercase tracking-[0.22em] text-[#A1A1AA]">
                AG-PRO-01
              </span>
            </div>
            <div className="relative flex-1 bg-white overflow-hidden">
              <img
                src={SHOWCASE_INFOGRAPHIC}
                alt="AdjustaGland PRO CAD engineering render"
                className="absolute left-0 right-0 w-full object-contain"
                style={{ top: "-125%", height: "350%" }}
              />
              <div className="absolute top-0 left-0 right-0 h-[6%] bg-white pointer-events-none" />
              <div className="absolute bottom-0 left-0 right-0 h-[6%] bg-white pointer-events-none" />
            </div>
          </div>

          {/* Packaging / box */}
          <div
            data-testid="showcase-packaging"
            className="lg:col-span-4 bg-[#0A0A0A] p-0 relative flex flex-col"
          >
            <div className="bg-[#0A0A0A] px-4 py-3 border-b border-[#27272A] flex items-center justify-between">
              <span className="font-mono-spec text-[10px] uppercase tracking-[0.22em] text-[#FF6B00]">
                Production Unit
              </span>
              <span className="font-mono-spec text-[10px] uppercase tracking-[0.22em] text-[#A1A1AA]">
                In Hand
              </span>
            </div>
            <div className="relative w-full flex-1 overflow-hidden bg-[#141414] min-h-[400px]">
              <img
                src="https://customer-assets-lxgj4vgw.emergentagent.net/job_gland-positioning/artifacts/312f969b062873e7_IMG_2308.png"
                alt="AdjustaGland PRO production unit in use"
                className="absolute inset-0 w-full h-full object-cover"
                style={{ objectPosition: "left center" }}
              />
            </div>
            <div className="px-4 py-3 border-t border-[#27272A] flex items-center justify-between">
              <span className="font-mono-spec text-[10px] uppercase tracking-[0.22em] text-[#A1A1AA]">
                SKU · AG-PRO-01
              </span>
              <span className="font-mono-spec text-[10px] uppercase tracking-[0.22em] text-[#A1A1AA]">
                Designed in the UK
              </span>
            </div>
          </div>
        </div>

        {/* Tagline strip */}
        <div className="mt-px bg-[#FF6B00] text-black px-6 md:px-10 py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 border border-[#FF6B00]">
          <div className="font-display text-xl md:text-2xl tracking-tight">
            Work Smarter. Mark Better.
          </div>
          <div className="font-mono-spec text-[10px] md:text-[11px] uppercase tracking-[0.22em] font-bold">
            AdjustaGland™ PRO · The Professional&apos;s Choice
          </div>
        </div>
      </div>
    </section>
  );
};
